import React from "react";
import "../css/style.css";
import Skills from "./Skills";
import Projects from "./Projects";
import ContactMe from "./ContactMe";
import AboutMe from "./AboutMe";

function Home() {
  return (
    <>
      {/* Hero */}
      <section className="hero">
        <div className="hero-label">Available for work</div>
        <h1 className="hero-name">
          Oluwabusola<br /><span>Ilechukwu</span>
        </h1>
        <p className="hero-role">
          Frontend-focused Full Stack Developer — building clean, accessible
          web experiences with React, Node.js, and a background in architecture.
        </p>
        <div className="hero-actions">
          <a href="#projects" className="btn-primary">View Projects</a>
          <a
            href="https://docs.google.com/document/d/1eHAUsdxh8J53QIvTRZA6ZmZHbiwiTMUaqt-bCDyoVdI/edit?usp=sharing"
            target="_blank"
            rel="noreferrer"
            className="btn-outline"
          >
            Resume ↗
          </a>
          <a
            href="https://www.linkedin.com/in/oluwabusola-jibodu-869418125/"
            target="_blank"
            rel="noreferrer"
            className="btn-outline"
          >
            LinkedIn ↗
          </a>
        </div>
        <div className="hero-scroll-hint">
          <span>↓</span>
          <span>scroll</span>
        </div>
      </section>

      <section id="about"><AboutMe /></section>
      <section id="skills"><Skills /></section>
      <section id="projects"><Projects /></section>
      <section id="contact"><ContactMe /></section>
    </>
  );
}

export default Home;
